var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2258_2970)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.975 5.733a.5.5 0 1 0-.707-.707L3.5 6.793 1.732 5.026a.5.5 0 1 0-.707.707L2.793 7.5 1.025 9.268a.5.5 0 1 0 .707.707L3.5 8.208l1.768 1.767a.5.5 0 1 0 .707-.707L4.207 7.501l1.768-1.768Z",
    fill: "#DE5454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2258_2970"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h7v14H0z"
  })))));
};

export default SvgDelete;